import { CommonEnums } from "../../common.enums";

export class GpsSubscriber_Inst {
  gpsSubscriber_inst_id: number;
  nm: string;
  description: string;
  ver: string;
  valid_Cd: string;
  dxFlow_Id: number;
  updateBy: string;
  lastUpdateBy: string;
  updateDt: Date;
  disableFlg: string;
  src_ConnNm: string;
  tgt_ConnNm: string;
  retryEnabled: string;
  numOfRetryAttempts: number;
  retryWaitTime: number;

  constructor() {
    this.setDefault();
  }

  setDefault(): void {
    this.gpsSubscriber_inst_id = CommonEnums.defaults.LONG_VAL;
    this.nm = CommonEnums.defaults.STRING_EMPTY;
    this.description = CommonEnums.defaults.STRING_EMPTY;
    this.ver = CommonEnums.defaults.STRING_EMPTY;
    this.valid_Cd = CommonEnums.defaults.STRING_EMPTY;
    this.dxFlow_Id = CommonEnums.defaults.LONG_VAL;
    this.updateBy = CommonEnums.defaults.STRING_EMPTY;
    this.lastUpdateBy = CommonEnums.defaults.STRING_EMPTY;
    this.updateDt = new Date();
    this.disableFlg = CommonEnums.defaults.STRING_VAL_NO;
    this.src_ConnNm = CommonEnums.defaults.STRING_EMPTY;
    this.tgt_ConnNm = CommonEnums.defaults.STRING_EMPTY;
    this.retryEnabled = CommonEnums.defaults.STRING_VAL_NO;
    this.numOfRetryAttempts = 2;
    this.retryWaitTime = 60;
  }

  get PrimaryKey(): string {
    return this.gpsSubscriber_inst_id + "." + this.dxFlow_Id;
  }

  copy(): GpsSubscriber_Inst {
    let googlesubscriberTmp: GpsSubscriber_Inst = new GpsSubscriber_Inst();

    googlesubscriberTmp.gpsSubscriber_inst_id = this.gpsSubscriber_inst_id;
    googlesubscriberTmp.nm = this.nm;
    googlesubscriberTmp.description = this.description;
    googlesubscriberTmp.ver = this.ver;
    googlesubscriberTmp.valid_Cd = this.valid_Cd;
    googlesubscriberTmp.dxFlow_Id = this.dxFlow_Id;
    googlesubscriberTmp.updateBy = this.updateBy;
    googlesubscriberTmp.lastUpdateBy = this.lastUpdateBy;
    googlesubscriberTmp.updateDt = this.updateDt;
    googlesubscriberTmp.disableFlg = this.disableFlg;
    googlesubscriberTmp.src_ConnNm = this.src_ConnNm;
    googlesubscriberTmp.tgt_ConnNm = this.tgt_ConnNm;
    googlesubscriberTmp.retryEnabled = this.retryEnabled;
    googlesubscriberTmp.numOfRetryAttempts = this.numOfRetryAttempts;
    googlesubscriberTmp.retryWaitTime = this.retryWaitTime;

    return googlesubscriberTmp;
  }

  copyFrom(gpsSubscriberTmp: GpsSubscriber_Inst): void {
    this.gpsSubscriber_inst_id = gpsSubscriberTmp.gpsSubscriber_inst_id;
    this.nm = gpsSubscriberTmp.nm;
    this.description = gpsSubscriberTmp.description;
    this.ver = gpsSubscriberTmp.ver;
    this.valid_Cd = gpsSubscriberTmp.valid_Cd;
    this.dxFlow_Id = gpsSubscriberTmp.dxFlow_Id;
    this.updateBy = gpsSubscriberTmp.updateBy;
    this.lastUpdateBy = gpsSubscriberTmp.lastUpdateBy;
    this.updateDt = gpsSubscriberTmp.updateDt;
    this.disableFlg = gpsSubscriberTmp.disableFlg;
    this.src_ConnNm = gpsSubscriberTmp.src_ConnNm;
    this.tgt_ConnNm = gpsSubscriberTmp.tgt_ConnNm;
    this.retryEnabled = gpsSubscriberTmp.retryEnabled;
    this.numOfRetryAttempts = gpsSubscriberTmp.numOfRetryAttempts;
    this.retryWaitTime = gpsSubscriberTmp.retryWaitTime;
  }

  compare(gpsSubscriberTmp: GpsSubscriber_Inst): string {
    let googleSubscriberString: string = this.toString(false);
    let googleSubscriberTmpString: string = gpsSubscriberTmp.toString(false);

    if (googleSubscriberString != googleSubscriberTmpString) {
      return googleSubscriberString + ", " + googleSubscriberTmpString;
    }

    return "";
  }

  toString(isNotCompare: boolean = true): string {
    let str: string =
      "GpsSubscriber_Inst [gpsSubscriber_inst_id =" +
      this.gpsSubscriber_inst_id +
      ", nm=" +
      this.nm +
      ", description=" +
      this.description +
      ", ver=" +
      this.ver +
      ", updateBy=" +
      this.updateBy +
      ", updateDt=" +
      this.updateDt +
      ", valid_Cd=" +
      this.valid_Cd +
      ", dxFlow_Id=" +
      this.dxFlow_Id +
      ", disableFlg=" +
      this.disableFlg +
      ",retryEnabled =" +
      this.retryEnabled +
      ",numOfRetryAttempts=" +
      this.numOfRetryAttempts +
      ", retryWaitTime= " +
      this.retryWaitTime;
    if (isNotCompare) {
      str +=
        ", lastUpdateBy=" +
        this.lastUpdateBy +
        ", src_ConnNm=" +
        this.src_ConnNm +
        ", tgt_ConnNm=" +
        this.tgt_ConnNm;
    }
    str += "]";
    return str;
  }
}
